// 广告信息模块键名
export const CAMPAIGN_MODULE_KEY = 'campaign_config';

// 创意信息模块键名
export const CREATIVE_MODULE_KEY = 'creative_config';

// 广告定向模块键名
export const TARGETING_MODULE_KEY = 'targeting_config';

// 图片/视频素材模块键名
export const MATERIAL_MODULE_KEY = 'material_config';

// 标题模块键名
export const TITLE_MODULE_KEY = 'title_config';

// 落地页模块键名
export const SITE_MODULE_KEY = 'site_config';

// 广告 - 基础配置表单键名
export const CAMPAIGN_BASE_FORM_KEY = 'base_form';

// 投放游戏表单键名
export const CAMPAIGN_DELIVERY_FORM_KEY = 'delivery_form';

// 广告版位表单键名
export const CAMPAIGN_SITE_FORM_KEY = 'site_form';

// 广告预算与出价表单键名
export const CAMPAIGN_BUDGET_AND_BID_FORM_KEY = 'budget_and_bid_form';

// 广告排期表单键名
export const CAMPAIGN_SCHEDULE_FORM_KEY = 'schedule_form';

// 创意-基础配置表单键名
export const CREATIVE_BASE_FORM_KEY = 'base_form';

// 创意-附加创意信息表单键名
export const CREATIVE_ADDITIONAL_FORM_KEY = 'additional_form';

// 创意-内容配置表单键名
export const CREATIVE_CONTENT_FORM_KEY = 'content_form';

// 创意-创意组件表单键名
export const CREATIVE_COMPONENTS_FORM_KEY = 'creative_components';
